// removed by extract-text-webpack-plugin
module.exports = {"colors":"\"styles/colors.css\"","zGreen":"#BFD730","zRed":"rgb(237, 85, 100)","checkbox":"r7S9","tapThis":"_1Rng","active":"_2F_3","disabled":"_3qOm","invalid":"_1_YF"};


//////////////////
// WEBPACK FOOTER
// ./~/@pickle/pickle-shared/src/components/Input/Checkbox/Checkbox.scss
// module id = 1Hpu
// module chunks = 0